export default "__VITE_ASSET__93e70485__"